import { useState, useEffect, useCallback } from 'react'
import { configApi } from '../services/configApi'
import { ConfigType } from '../types/config'
import { BrandPaletteEntry } from '../types/gotypes'

export default function useBrandPalette(customer: string, job: string) {
  const [palette, setPalette] = useState<Record<string, BrandPaletteEntry> | undefined>()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!customer || !job) return
    setIsLoading(true)
    configApi
      .getMergedConfig(customer, job, {
        config_type: ConfigType.Job,
        customer,
        job,
      })
      .then((result) => {
        setPalette(result.data?.brand_palette)
      })
      .catch(() => {
        // Config may not exist yet
      })
      .finally(() => setIsLoading(false))
  }, [customer, job])

  const savePalette = useCallback(
    async (newPalette: Record<string, BrandPaletteEntry> | undefined) => {
      if (!customer || !job) return

      // Find existing job config
      const configs = await configApi.listConfigs(customer, job, {
        config_type: ConfigType.Job,
        customer,
        job,
      })

      const existing = configs.find(
        (c) => c.config_type === ConfigType.Job && c.customer === customer && c.job === job
      )

      if (existing) {
        await configApi.updateConfig(customer, job, existing.id, {
          ...existing,
          data: { ...existing.data, brand_palette: newPalette },
        })
      } else {
        await configApi.createConfig(customer, job, {
          config_type: ConfigType.Job,
          customer,
          job,
          data: { brand_palette: newPalette },
        })
      }

      setPalette(newPalette)
    },
    [customer, job]
  )

  return { palette, savePalette, isLoading }
}
